import type { GasPayload } from '@atlaskit/analytics-gas-types';
import {
	promptOfTheDayTaskFailEvent,
	promptOfTheDayTaskSuccessEvent,
	type PromptOfTheDayFallback,
} from '@atlassian/rovo-prompt-of-the-day/analytics';

export const onPromptOfTheDayTaskSuccess: ({
	attributes,
	promptCount,
}: {
	attributes: Record<string, unknown>;
	promptCount: number;
}) => GasPayload = ({ attributes, promptCount }) => ({
	source: 'searchDialog',
	...promptOfTheDayTaskSuccessEvent({ attributes, promptCount }),
	actionSubjectId: 'preQuerySearchResults',
});

export const onPromptOfTheDayTaskFail: ({
	attributes,
	fallback,
}: {
	attributes: Record<string, unknown>;
	fallback: PromptOfTheDayFallback;
}) => GasPayload = ({ attributes, fallback }) => ({
	source: 'searchDialog',
	...promptOfTheDayTaskFailEvent({ attributes, fallback }),
	actionSubjectId: 'preQuerySearchResults',
});
